/* eslint-disable @typescript-eslint/naming-convention */
export interface ISpecialty {
  id: number;
  title: string;
  tag: string;
  isTopSelection: boolean;
}

export interface ISpecialtyApiResponse {
  id: number;
  title: string;
  tag: string;
  is_top_selection: boolean;
}

export interface IConcernOptionValue {
  id: number;
  isModality: boolean;
  isTopSelection: boolean;
  title?: string;
  isPsychiatrist?: boolean;
}

export const PSYCHIATRIST_ID = -1;
export const PSYCHIATRIST_TITLE = 'Psychiatry';

// Mapping for URL-safe titles
export const PSYCHIATRIST_URL_TITLE = 'psychiatric';
export const THERAPY_TITLE = 'Therapy';
export const THERAPY_URL_TITLE = 'therapy';
